import axios, { AxiosResponse } from 'axios';
import { LoggerService } from './LoggerService';

axios.defaults.withCredentials = true;

let tokenPromise: Promise<void> | null = null;

const setupAxiosToken = async () => {
  if (window) {
    const queryParameters = new URLSearchParams(window.location.search);
    const xSignature = queryParameters.get('x-signature');
    if (xSignature) {
      axios.defaults.headers.common.Authorization = `Signature ${xSignature}`;
      window.localStorage.setItem('xSignature', xSignature);
    }
  }
};

const ensureTokenInitialized = () => {
  if (!tokenPromise) {
    tokenPromise = setupAxiosToken();
  }
  return tokenPromise;
};

export class HttpAdapter {
  static async get(url: string, config?: object): Promise<AxiosResponse> {
    await ensureTokenInitialized();

    try {
      return await axios.get(url, config);
    } catch (error: any) {
      LoggerService.error('GET request failed', {
        url,
        status: error?.response?.status,
        error: error?.message,
      });
      throw error;
    }
  }

  static async post(url: string, body: object, config?: object): Promise<AxiosResponse> {
    await ensureTokenInitialized();

    try {
      return await axios.post(url, body, config);
    } catch (error: any) {
      LoggerService.error('POST request failed', {
        url,
        status: error?.response?.status,
        error: error?.message,
      });
      throw error;
    }
  }

  static async put(url: string, body: object, config?: object): Promise<AxiosResponse> {
    await ensureTokenInitialized();

    try {
      return await axios.put(url, body, config);
    } catch (error: any) {
      LoggerService.error('PUT request failed', {
        url,
        status: error?.response?.status,
        error: error?.message,
      });
      throw error;
    }
  }

  static async delete(url: string, config?: object): Promise<AxiosResponse> {
    await ensureTokenInitialized();

    try {
      return await axios.delete(url, config);
    } catch (error: any) {
      LoggerService.error('DELETE request failed', {
        url,
        status: error?.response?.status,
        error: error?.message,
      });
      throw error;
    }
  }
}
